import { Controller } from '@hotwired/stimulus'

const DEFAULT_INTERVAL_MS = 12000

export default class extends Controller {
  static targets = ['badge', 'button']
  static values = {
    apiBase: String,
    interval: { type: Number, default: DEFAULT_INTERVAL_MS }
  }

  connect() {
    if (window.ondeviceai || window.innerWidth < 1200) return
    this._abort = null
    this.poll()
    this._timer = window.setInterval(() => this.poll(), this.intervalValue || DEFAULT_INTERVAL_MS)
  }

  _stopPolling() {
    if (this._timer) {
      window.clearInterval(this._timer)
      this._timer = null
    }
  }

  disconnect() {
    this._stopPolling()
    if (this._abort) {
      this._abort.abort()
      this._abort = null
    }
  }

  focusWidget(event) {
    event?.preventDefault()
    window.dispatchEvent(new CustomEvent('call-center:focus'))
    const float = document.getElementById('call-center-float-container')
    if (float) {
      float.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
    }
  }

  async poll() {
    if (!this.apiBaseValue) return
    if (this._abort) this._abort.abort()
    this._abort = new AbortController()

    try {
      const response = await fetch(`${this.apiBaseValue}/call_sessions/active_count`, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' },
        signal: this._abort.signal
      })
      if (response.status === 401 || response.status === 403) {
        this._stopPolling()
        return
      }
      if (!response.ok) return
      const data = await response.json()
      this._renderBadge(Number(data.active_calls) || 0)
    } catch (err) {
      if (err?.name === 'AbortError') return
      // Keep last known badge on transient network errors
    }
  }

  _renderBadge(count) {
    if (!this.hasBadgeTarget) return
    const badge = this.badgeTarget
    if (count > 0) {
      badge.textContent = String(count)
      badge.classList.remove('d-none')
      this.buttonTarget?.classList.add('has-active-calls')
    } else {
      badge.textContent = '0'
      badge.classList.add('d-none')
      this.buttonTarget?.classList.remove('has-active-calls')
    }
  }
}
